import styles from './ScoopFallback.module.scss'
import { ScoopButton, ScoopCenter, ScoopColumn, ScoopRow, ScoopText } from '../../ui'
import ScoopLogo from '../../../assets/common/ScoopLogo.svg'
import { BugBeetleIcon, FileXIcon } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'
import { EVENTS, trackEvent } from '../../../events'

export const ScoopFallback = ({ notFound }) => {
    const navigate = useNavigate()

    return (
        <ScoopColumn className={styles.errorBoundaryScreen}>
            <header className={styles.header}>
                <ScoopCenter className={styles.logoContainer}>
                    <img src={ScoopLogo} alt="Scoop Logo" className={styles.logo} />
                </ScoopCenter>
            </header>
            <div className={styles.iconContainer}>
                {notFound ? (
                    <FileXIcon color={'#e50b54'} size={40} />
                ) : (
                    <BugBeetleIcon color={'#e50b54'} size={40} />
                )}
            </div>
            <ScoopText className={styles.titleText}>
                {notFound ? 'Oops… page not found!' : 'Oops… something went wrong!'}
            </ScoopText>
            <ScoopText className={styles.descriptionText}>
                {notFound
                    ? "We can't seem to find the page you are looking for."
                    : 'It looks like there was an issue on our end. Our team has been notified and is working to resolve it.'}
            </ScoopText>
            <ScoopRow className={styles.supportContainer}>
                <ScoopText className={styles.supportText}>
                    Please try again later. If the problem continues, reach out to us at&nbsp;
                </ScoopText>
                <ScoopText
                    className={styles.supportLink}
                    onClick={() => {
                        trackEvent(EVENTS.ACCOUNT.CONTACT_SUPPORT, { source: 'error_fallback' })
                        window.location = 'mailto:support@scoopanalytics.com'
                    }}
                >
                    support@scoopanalytics.com
                </ScoopText>
            </ScoopRow>
            <ScoopButton
                variant="primary"
                onClick={notFound ? () => navigate('/canvas') : () => window.location.reload()}
                className={styles.continueButton}
            >
                {notFound ? 'Go home' : 'Reload page'}
            </ScoopButton>
        </ScoopColumn>
    )
}
